<template>

    <div class="shippings_block container">
            <div v-if="!selectEnvio&&!selectFacturacion" class="info_data_order_block row">

                <div class="col-md-6 address_block">
                    <div class="head">
                        <img src="/img/iconos/icon_direccion.svg" alt="icon_direccion.svg">
                        <h3>Dirección de envío</h3>
                    </div>
                    <div class="body">
                        <div class="bp-form-group">
                            <div class="content-group">
                                <div class="type-client-selection">
                                    <div>
                                        <div class="radio-input-block">
                                            <div class="radio-input-item">
                                                <input type="radio" tabindex="0" id="ship_address" v-model="form.direccionEnvio" :value="direccionEnvioData.id">
                                                <label class="text" for="ship_address">
                                                    <span>{{direccionEnvioData.nombre}} {{direccionEnvioData.apellidos}}</span>
                                                    <span>{{direccionEnvioData.direccion}}</span>
                                                    <span>{{direccionEnvioData.poblacion_nombre}} ({{direccionEnvioData.cod_postal}})</span>
                                                    <span>{{direccionEnvioData.provincia.nombre}}, ({{direccionEnvioData.pais.nombre}})</span>
                                                </label>
                                                <div class="icons">
                                                    <i class="fas fa-pencil-alt" @click="selectEnvio=true"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="foot">
                        <div class="bp-form-group">
                            <div class="content-group">
                                <div class="type-client-selection">
                                    <div>
                                        <div class="radio-input-block">
                                            <div class="radio-input-item">
                                                <input type="radio" tabindex="0" id="new_address1" v-model="form.direccionEnvio" value="0">
                                                <label class="text" for="new_address1">
                                                    <span>Añadir nueva dirección</span>
                                                </label>
                                                <address-create-cart v-if="activeCreate1" prefixid="active1"></address-create-cart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 address_block">
                    <div class="head">
                        <img src="/img/iconos/icon_facturacion.svg" alt="icon_facturacion.svg">
                        <h3>Dirección de facturación</h3>
                    </div>
                    <div class="body">
                        <div class="bp-form-group">
                            <div class="content-group">
                                <div class="type-client-selection">
                                    <div>
                                        <div class="radio-input-block">
                                            <div class="radio-input-item">
                                                <input type="radio" tabindex="0" id="factura_address" v-model="form.direccionFacturacion"  :value="direccionFacturacionData.id">
                                                <label class="text" for="factura_address">
                                                    <span>{{direccionFacturacionData.nombre}} {{direccionFacturacionData.apellidos}}</span>
                                                    <span>{{direccionFacturacionData.direccion}}</span>
                                                    <span>{{direccionFacturacionData.poblacion_nombre}} ({{direccionFacturacionData.cod_postal}})</span>
                                                    <span>{{direccionFacturacionData.provincia.nombre}}, ({{direccionFacturacionData.pais.nombre}})</span>
                                                </label>
                                                <div class="icons">
                                                    <i class="fas fa-pencil-alt" @click="selectFacturacion=true"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="foot">
                        <div class="bp-form-group">
                            <div class="content-group">
                                <div class="type-client-selection">
                                    <div>
                                        <div class="radio-input-block">
                                            <div class="radio-input-item">
                                                <input type="radio" tabindex="0" name="direccionFacturacion" id="new_address2" v-model="form.direccionFacturacion" value="0">
                                                <label class="text" for="new_address2">
                                                    <span>Añadir nueva dirección</span>
                                                </label>
                                                <address-create-cart v-if="activeCreate2"></address-create-cart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 ship_method_block">
                    <div class="head">
                        <img src="/img/iconos/icon_paquete.svg" alt="icon_paquete.svg">
                        <h3>Método de envío</h3>
                    </div>
                    <div class="body">
                        <div v-if="loading_shipping" class="row">
                            <load-spiner></load-spiner>
                        </div>
                        <div v-else class="bp-form-group">
                            <div class="content-group">
                                <div class="type-client-selection">
                                    <div>
                                        <div v-if="!shareShip" class="radio-input-block">
                                            <div v-for="envio in envios" class="radio-input-item">
                                                <input type="radio" tabindex="0" @change="submitDatosEnvio(envio.precio.precio)" :id="'metodoEnvio_'+envio.transportista.id" name="metodoEnvio" v-model="form.metodoEnvio" :value="envio.transportista.id">
                                                <label class="text" :for="'metodoEnvio_'+envio.transportista.id">
                                                    <span>{{envio.transportista.nombre}}: {{(envio.precio.precio>0)?envio.precio.precio+'€':'GRATIS'}}</span>
                                                    <span style="font-size: 11px;" v-if="envio.transportista.descripcion" v-html="envio.transportista.descripcion"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div v-else class="radio-input-block">
                                            <div class="radio-input-item">
                                                <input type="radio" tabindex="0" checked>
                                                <label class="text">
                                                    <span>Gastos de envio compartidos: GRATIS</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="selectEnvio" class="info_data_order_block row">
                <div class="col-md-12 address_block">
                    <div class="head">
                        <img src="/img/iconos/icon_direccion.svg" alt="icon_direccion.svg">
                        <h3>Dirección de envío</h3>
                    </div>
                    <div class="body">
                        <div class="bp-form-group">
                            <div class="content-group">
                                <div class="type-client-selection">
                                    <div>
                                        <div class="radio-input-block">
                                            <div v-for="(direccion, index) in direcciones" class="radio-input-item massive">
                                                <input type="radio" tabindex="0" :id="'ship_address_select'+direccion.id" :name="'direccionEnvio_select_'+direccion.id" v-model="form.direccionEnvio" :value="direccion.id">
                                                <label class="text" :for="'ship_address_select'+direccion.id">
                                                    <span>{{direccion.nombre_direccion}}</span>
                                                    <span>{{direccion.nombre}} {{direccion.apellidos}}</span>
                                                    <span>{{direccion.direccion}}</span>
                                                    <span>{{direccion.poblacion_nombre}} ({{direccion.cod_postal}})</span>
                                                    <span>{{direccion.provincia.nombre}}, ({{direccion.pais.nombre}})</span>
                                                </label>
                                                <div class="icons">
                                                    <i class="fas fa-pencil-alt" @click="editAddress(index)"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3" style="text-align: center;">
                    <a class="button_cart_style_alt" @click="selectEnvio=false"><div><span>Volver</span></div></a>
                </div>
            </div>
            <div v-if="selectFacturacion" class="info_data_order_block row">
                <div class="col-md-12 address_block">
                    <div class="head">
                        <img src="/img/iconos/icon_facturacion.svg" alt="icon_facturacion.svg">
                        <h3>Dirección de facturación</h3>
                    </div>
                    <div class="body">
                        <div class="bp-form-group">
                            <div class="content-group">
                                <div class="type-client-selection">
                                    <div>
                                        <div class="radio-input-block">
                                            <div v-for="(direccion, index) in direcciones" class="radio-input-item massive">
                                                <input type="radio" tabindex="0" :id="'factu_address_select'+direccion.id" :name="'direccionFacturacion_select_'+direccion.id" v-model="form.direccionFacturacion" :value="direccion.id">
                                                <label class="text" :for="'factu_address_select'+direccion.id">
                                                    <span>{{direccion.nombre_direccion}}</span>
                                                    <span>{{direccion.nombre}} {{direccion.apellidos}}</span>
                                                    <span>{{direccion.direccion}}</span>
                                                    <span>{{direccion.poblacion_nombre}} ({{direccion.cod_postal}})</span>
                                                    <span>{{direccion.provincia.nombre}}, ({{direccion.pais.nombre}})</span>
                                                </label>
                                                <div class="icons">
                                                    <i class="fas fa-pencil-alt" @click="editAddress(index)"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3" style="text-align: center;">
                    <a class="button_cart_style_alt" @click="selectFacturacion=false"><div><span>Volver</span></div></a>
                </div>
            </div>

            <!-- EDITAR DIRECCIONES FORM -->
            <b-modal id="modal-update-direccion" ref="modal_edit" title="Actualizar dirección" size="md" hide-footer>
                <address-edit-cart @exit="updateAddress()" :direccion="form_edit"></address-edit-cart>
            </b-modal>
    </div>

</template>

<script>
    import lodash from "lodash";
    export default {
        props: ['direcciones','direccionEnvio','direccionFacturacion','unidadesData','shareShip','metodoEnvio'],
        data() {
            return {
                loading_shipping: true,

                direccionEnvioData : lodash.cloneDeep(this.direccionEnvio),
                direccionFacturacionData : lodash.cloneDeep(this.direccionFacturacion),
                envios: [],

                form: {
                    direccionEnvio: "",
                    direccionFacturacion: "",
                    metodoEnvio: ""
                },

                activeCreate1: false,
                activeCreate2: false,

                selectEnvio: false,
                selectFacturacion: false,

                form_edit: ""
            }
        },
        mounted() {
            this.form.direccionEnvio = this.direccionEnvioData.id;
            this.form.direccionFacturacion = this.direccionFacturacionData.id;
            this.form.metodoEnvio = this.metodoEnvio;

            this.loadShippingMethods();

            this.$on('loadAddressClient', function(){
                this.activeCreate1=false;
                this.activeCreate2=false;
                this.$parent.loadAddressClient();
            });
        },
        watch: {
             "direcciones": function(newVal, oldVal) {
                 if(this.direcciones&&this.direcciones.find(i=>i.id==this.form.direccionEnvio)){
                     this.direccionEnvioData = this.direcciones.find(i => i.id==this.form.direccionEnvio);
                     this.$parent.orderData.direccion_envio = this.direccionEnvioData;
                 }
                 if(this.direcciones&&this.direcciones.find(i=>i.id==this.form.direccionFacturacion)){
                     this.direccionFacturacionData = this.direcciones.find(i => i.id==this.form.direccionFacturacion);
                     this.$parent.orderData.direccion_facturacion = this.direccionFacturacionData;
                 }
            },
            "form.direccionEnvio": function(newVal, oldVal) {
                if (newVal<=0){
                    this.activeCreate1=true;
                }else{
                    this.activeCreate1=false;
                    if(this.direcciones&&this.direcciones.find(i=>i.id==newVal)){
                        this.direccionEnvioData = this.direcciones.find(i=>i.id==newVal);
                    }
                    this.$parent.orderData.direccion_envio_id = newVal;
                    this.$parent.orderData.direccion_envio = this.direccionEnvioData;
                }
            },
            "form.direccionFacturacion": function(newVal, oldVal) {
                if (newVal<=0){
                    this.activeCreate2=true;
                }else{
                    this.activeCreate2=false;
                    if(this.direcciones&&this.direcciones.find(i=>i.id==newVal)){
                        this.direccionFacturacionData = this.direcciones.find(i=>i.id==newVal);
                    }
                    this.$parent.orderData.direccion_facturacion_id = newVal;
                    this.$parent.orderData.direccion_facturacion = this.direccionFacturacionData;
                }
            },
            "unidadesData": function (newVal, oldVal) {
                this.loadShippingMethods();
            }
        },
        methods: {
            editAddress: function (index) {
                this.form_edit = this.direcciones[index];
                this.$refs.modal_edit.show();
            },
            updateAddress: function () {
                this.$refs.modal_edit.hide();
                this.$parent.loadAddressClient();
            },
            loadShippingMethods: function () {
                this.loading_shipping = true;

                axios.post(this.route('account.pedidos.get-shipping-methods'),{
                    direccion_id: this.direccionEnvioData.id,
                    unidades: this.unidadesData,
                }).then(response => {
                    this.envios = response.data.transportistas;
                    this.submitDatosEnvio(this.envios.find(i => i.transportista.id==this.metodoEnvio).precio.precio);

                    this.loading_shipping = false;
                }).catch(e => {
                    console.log(e);
                });
            },
            submitDatosEnvio(precio_envio) {
                this.$parent.orderData.importe_envio = precio_envio;
                this.$parent.orderData.transportista_id = this.form.metodoEnvio;

                this.$parent.updateTotals();
            },
        }
    }
</script>
